module.exports = __webpack_public_path__ + "static/fb-icon-babbab82248a77aba6d97a4b986f52c3.jpg";